import React from 'react';
import './ProcessCfgModal.css';

export default function ProcessCfgModal({ open, onClose, title, children, footer }) {
  if (!open) return null;
  return (
    <div
      className="process-cfg-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="process-cfg-modal-title"
      onClick={onClose}
    >
      <div className="process-cfg-modal" onClick={(e) => e.stopPropagation()}>
        <div className="process-cfg-modal-header">
          <h3 id="process-cfg-modal-title" className="process-cfg-modal-title">
            {title}
          </h3>
          <button type="button" className="process-cfg-modal-close" onClick={onClose} title="Fechar">
            ✕
          </button>
        </div>
        <div className="process-cfg-modal-body">{children}</div>
        <div className="process-cfg-modal-footer">
          {footer || (
            <button type="button" className="process-cfg-modal-btn process-cfg-modal-btn-secondary" onClick={onClose}>
              Fechar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
